import React, { useContext } from "react";

import { useNavigate } from "react-router-dom";

import BtnPlain from "../../../../../../Components/Buttons/BtnPlain";

import { ActionBtn } from "../../../../../../Components/FinalTable";

import { FiEdit2 } from "react-icons/fi";

import { FaRegTrashAlt } from "react-icons/fa";

import useAxios from "../../../../../../Hooks/useAxios";

import useApp from "../../../../../../Hooks/useApp";

import AllProceduresContext from "../context/AllProceduresContext";

const TableActions = ({ doc }) => {
  const navigate = useNavigate();
  const request = useAxios();
  const { setShowSuccessModal, setModalMessage } = useApp();
  const { data, setData, getInitProcedures } = useContext(AllProceduresContext);

  const handleDelete = async () => {
    let res = await request({
      method: "DELETE",
      url: `hospital/procedure/${doc.id}`,
    });

    if (res !== "error") {
      setModalMessage("Procedure Deleted!");
      setShowSuccessModal(true);
      getInitProcedures()
    }

  };

  return (
    <div className="flex-1">
      {/* <TableHorizontalActionBtn /> */}
      <ActionBtn next={() => navigate(`view/${doc.id}`)}>
        <div className=" gap-y-2 flex flex-col text-sm">
          <BtnPlain
            activeBgColor="white"
            bg="white"
            click={() => navigate(`edit/${doc.id}`)}
          >
            <div className=" gap-x-2 flex items-center active:opacity-50 cursor-pointer">
              <p className="  text-primary">
                <FiEdit2 />
              </p>
              <p className=" ">Edit Procedure</p>
            </div>
          </BtnPlain>
          <BtnPlain activeBgColor="white" bg="white" click={handleDelete}>
            <div className=" gap-x-2 flex items-center active:opacity-50 cursor-pointer">
              <p className="  text-red">
                <FaRegTrashAlt />
              </p>
              <p className=" ">Delete Procedure</p>
            </div>
          </BtnPlain>
        </div>
      </ActionBtn>
    </div>
  );
};

export default TableActions;
